import moment, { Moment } from 'moment';

export const getNextSevenDays = (date: Moment = moment()) => {
  return new Array(7).fill({}).map((_, index) => ({
    date: moment(date).add(index, 'days'),
    dateString: moment(date).add(index, 'days').format('YYYY-MM-DD '),
  }));
};
